const companyType = Object.assign({
  GMBH: { name: 'GmbH', value: 'GmbH' },
  AG: { name: 'AG', value: 'AG' },
  UG: { name: 'UG', value: 'UG' },
  GMBH_CO_KG: { name: 'GmbH & Co. KG', value: 'GmbH & Co. KG' },
  KG: { name: 'KG', value: 'KG' },
  STIFTUNG: { name: 'Stiftung', value: 'Stiftung' },
  FDN: { name: 'FDN', value: 'FDN' },
  GBR: { name: 'GbR', value: 'GbR' },
});

Object.freeze(companyType);

function getEnumAsArray() {
  return Object.keys(companyType)
    .map(key => ({
      name: companyType[key].name,
      value: companyType[key].value,
    }));
}

export const companyTypeArray = getEnumAsArray();



// WEBPACK FOOTER //
// ./src/enum/user/CompanyType.js